import React from 'react'

/* doc
---
title: Message
name: Message
category: React - Bulma
---

A `Message` component based on Bulma `.message`. This is used to display a message
to the user.

This should be used with `MessageHeader`, and `MessageBody` components.

This component is the default message style, for different styles, see the
other message variant components below.

See [Bulma Documentation](http://bulma.io/documentation/components/message/) for reference and full options.
If one of the Bulma options isn't listed below, it may be added using the `className` prop.


```html_example
  <Message>
    <MessageHeader>...</MessageHeader>
    <MessageBody>
      ...
    </MessageBody>
  </Message>
```
*/
function Message(props) {
  const { className, children, ...rest } = props

  const classes = [
    'message',
    className || '',
  ]

  return (
    <div {...rest} className={classes.join(' ')}>
      {children}
    </div>
  )
}

export default Message
